export default {
	Address: 1,
	Email: 2,
	Name: 3,
	Phone: 4
};
